import type { GetStaticPropsContext } from 'next'
import {
  getGlobalContent
} from '@lib/sanity.queries'
import Kits from '@components/activateKit'
import TRANSLATIONS from '@locales/index'
export async function getStaticProps({
  preview,
  locale = 'de',
  locales,
}: GetStaticPropsContext) {
  const global = await getGlobalContent({ lang: locale }, preview)

  return {
    props: { global, messages: TRANSLATIONS[locale] },
  }
}

export default Kits
